/* ANALYTICS UTILS METHODS */
(function($) {
	"use strict";

	var CUBE = window.CUBE || {};
	var fwk = CUBE.Anly ? CUBE.Anly : { Anly: {} };

	fwk.utils = {
    /**
     * IS VISIBLE
     * 	Check if an element is visible in the viewport
     */
    isVisible: function($elt, offset) {
      var viewport = {};
      viewport.top = $(window).scrollTop();
      viewport.bottom = viewport.top + $(window).height();
      var bounds = {};
      bounds.top = $elt.offset().top;
      bounds.bottom = bounds.top + $elt.outerHeight();
      if (offset) bounds.top = bounds.top - offset;
      return ((bounds.top <= viewport.bottom) && (bounds.bottom >= viewport.top));
    },
  };
  window.CUBE.Anly = fwk;
})(jQuery);



// WEBPACK FOOTER //
// ./src/analytics/transcript-workaround/utils.js